const InitialFilter = [
  {
    label: 'nonVerifiedCust.all',
    value: [1, 2, 3, 4, 6, 8, 9, 10, 11, 12, 13],
    name: 'All',
    customerSource: null,
  },
  {
    label: 'nonVerifiedCust.otpVerifyPending',
    value: [2, 1],
    name: 'OTP Verification Pending',
    icon: 'CautionOutlined',
    customerSource: null,
  },
  {
    label: 'nonVerifiedCust.applicationPending',
    value: [3, 4, 6, 8, 9, 10, 11, 12, 13],
    name: 'application pending',
    icon: 'DocumentOutlined',
    customerSource: null,
  },
]
export { InitialFilter }
